import { FormsActions, FormsActionTypes } from '@appStore/selfservice/actions';
import { FormCategory } from '@model';

export interface State {
  data: FormCategory[];
  text: string;
  loaded: boolean;
  loading: boolean;
}

export const initialState: State = {
  data: null,
  text: null,
  loaded: false,
  loading: false
};

export function reducer(state = initialState, action: FormsActions): State {

  switch (action.type) {
    case FormsActionTypes.LoadFormCategoriesData:
      return { ...state, loaded: false, loading: true };
    case FormsActionTypes.LoadFormCategoriesDataSuccess:
      return {
        ...state,
        loaded: true,
        loading: false,
        data: action.payload.formCategories,
        text: action.payload.groupsText
      };
    case FormsActionTypes.LoadFormCategoriesDataFail:
      return { ...state, loaded: false, loading: false };
    }
    return state;
}

export const getFormCategories = (state: State) => state.data;
export const getFormCategoriesText = (state: State) => state.text;
export const getFormCategoriesLoaded = (state: State) => state.loaded;
export const getFormCategoriesLoading = (state: State) => state.loading;



